import React, { useState, useEffect } from 'react';
import api from '../utils/api';

const DisclaimerModal = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [disclaimerText, setDisclaimerText] = useState('');

    useEffect(() => {
        const hasAccepted = localStorage.getItem('disclaimer_accepted');
        if (!hasAccepted) {
            api.getSystemSettings().then(data => {
                if (data && data.homeDisclaimer) {
                    setDisclaimerText(data.homeDisclaimer);
                }
                setIsVisible(true);
            }).catch(err => {
                console.error("Failed to load disclaimer", err);
                setIsVisible(true);
            });
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('disclaimer_accepted', 'true');
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div className="fixed bottom-0 left-0 w-full z-[99999] bg-white border-t border-slate-100 shadow-[0_-10px_40px_rgba(0,0,0,0.1)] p-4 md:p-6 animate-in slide-in-from-bottom duration-500">
            <div className="max-w-[1400px] mx-auto flex flex-col md:flex-row items-center md:items-start gap-4 md:gap-8">
                {/* Icon */}
                <div className="hidden md:flex w-12 h-12 rounded-full bg-slate-50 items-center justify-center text-slate-400 shrink-0 border border-slate-100">
                    <i className="fa-solid fa-circle-info text-2xl"></i>
                </div>

                {/* Text Content */}
                <div className="flex-1 max-h-[150px] md:max-h-none overflow-y-auto">
                    <h4 className="text-base font-bold text-black mb-2">Disclaimer</h4>
                    <div className="text-[11px] md:text-[13px] text-black leading-relaxed font-normal space-y-2">
                        {disclaimerText ? (
                            disclaimerText.split('\n').map((paragraph, idx) => (
                                paragraph.trim() && <p key={idx}>{paragraph}</p>
                            ))
                        ) : (
                            <>
                                <p>
                                    The information provided on the My Property Guru website is intended solely for general information, research, and guidance purposes. Property details, pricing, images, specifications, amenities, project information, and availability may be sourced from builders, RERA, public portals, and other third-party sources. While My Property Guru strives to keep all information accurate and up to date, no representation or warranty of any kind, express or implied, is made regarding the completeness, accuracy, reliability, or suitability of the information provided.
                                </p>
                                <p>
                                    All information displayed on this website is subject to change without prior notice. Prospective buyers or clients are advised to independently verify all project-related details, including legal approvals, RERA registration, measurements, layouts, pricing, availability, and specifications through builders, official documents, or professional advisors before making any real estate-related decision.
                                </p>
                                <p>
                                    My Property Guru is an information and guidance-based platform only. Any property displayed on the website should not be considered as legal, financial, investment, or final purchase advice. Users are strongly encouraged to conduct their own due diligence and seek professional consultation before proceeding with any transaction, booking, purchase, sale, or investment.
                                </p>
                                <p>
                                    Property prices, offers, specifications, and availability are subject to change from time to time and do not constitute a final commitment or booking guarantee. My Property Guru shall not be held responsible or liable for any loss, damage, expense, or consequence arising from reliance on the information available on this website.
                                </p>
                            </>
                        )}
                    </div>
                </div>

                {/* Action Button */}
                <div className="shrink-0 w-full md:w-auto">
                    <button
                        onClick={handleAccept}
                        className="w-full md:w-auto px-10 py-3 bg-[#f87171] text-white hover:bg-rose-600 rounded-lg font-bold text-sm transition-all active:scale-95 shadow-lg shadow-rose-100"
                    >
                        OK
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DisclaimerModal;
